'use strict';exports.__esModule = true;var getCookie = exports.getCookie = function getCookie(name) {
  var matches = document.cookie.match(new RegExp('(?:^|; )' +
  name + '=([^;]*)'));

  return matches ? decodeURIComponent(matches[1]) : undefined;
};

/**
    * @param options - { expires, path, domain, secure }
    */
var setCookie = exports.setCookie = function setCookie(name, value, options) {
  options = options || {};

  var expires = options.expires;

  if (typeof expires === 'number' && expires) {
    var date = new Date();
    date.setTime(date.getTime() + expires * 1000);
    expires = date;
    options.expires = date;
  }
  if (expires && expires.toUTCString) {
    options.expires = expires.toUTCString();
  }

  value = encodeURIComponent(value);

  var updatedCookie = name + '=' + value;

  for (var propName in options) {
    if (Object.prototype.hasOwnProperty.call(options, propName)) {
      var propValue = options[propName];

      if (propName !== 'secure' || propValue === true) {
        updatedCookie += '; ' + propName;
      }

      if (propName !== 'secure') {
        updatedCookie += '=' + propValue;
      }
    }
  }
  document.cookie = updatedCookie;
};

var deleteCookie = exports.deleteCookie = function deleteCookie(name) {
  setCookie(name, '', {
    expires: new Date(0),
    path: '/' });

};


//////////////////
// WEBPACK FOOTER
// ./src/utils/cookiesManage.js
// module id = 3101
// module chunks = 0